import React, { useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import axios from 'axios';
import StoryCard from './StoryCard';
import LogoSvg from './LogoSvg';
import '../components.css';

const Favorites = ({ authUser, onLogout }) => {
  const navigate = useNavigate();
  const [favorites, setFavorites] = useState([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (authUser) {
      fetchFavorites();
    } else {
      setLoading(false);
    }
  }, [authUser]);

  const fetchFavorites = async () => {
    try {
      setLoading(true);
      const response = await axios.get('/api/favorites');
      setFavorites(Array.isArray(response.data) ? response.data : []);
      setError(null);
    } catch (err) {
      console.error('Failed to fetch favorites:', err);
      setError('Failed to load favorites');
      setFavorites([]);
    } finally {
      setLoading(false);
    }
  };

  const handleAdminClick = () => {
    navigate('/admin');
  };

  if (!authUser) {
    return (
      <div className="container py-5 text-center">
        <h2>Please log in to view your favorites</h2>
        <button className="btn btn-primary mt-3" onClick={() => navigate('/')}>
          Go to Login
        </button>
      </div>
    );
  }

  return (
    <div className="full-height-container">
      {/* Header */}
      <header className="site-header site-header-style">
        <div className="container">
          <nav className="navbar navbar-expand-lg navbar-light py-3">
            <div className="d-flex justify-content-between align-items-center w-100">
              <LogoSvg 
                alt="Arkansas Electric Cooperatives, Inc." 
                className="logo-large"
                onClick={() => navigate('/')}
                style={{ cursor: 'pointer' }}
              />
              <div className="d-flex align-items-center gap-3">
                <button 
                  className="btn btn-outline-primary px-4 py-2"
                  onClick={() => navigate('/archive')}
                >
                  Archive
                </button>
                {authUser && authUser.is_admin && (
                  <button 
                    className="btn btn-success px-4 py-2 btn-success-custom"
                    onClick={handleAdminClick}
                  >
                    Admin Panel
                  </button>
                )}
                {authUser && (
                  <button 
                    className="btn btn-outline-secondary px-4 py-2"
                    onClick={onLogout}
                  >
                    Logout
                  </button>
                )}
              </div>
            </div>
          </nav>
        </div>
      </header>

      {/* Favorites Content */}
      <section className="section-primary py-5">
        <div className="container">
          <div className="text-center mb-5">
            <h2 className="section-title">MY FAVORITES</h2>
            <p className="section-subtitle">Your pinned stories</p>
          </div>

          {loading ? (
            <div className="text-center py-5">
              <div className="spinner-border text-primary" role="status">
                <span className="visually-hidden">Loading...</span>
              </div>
            </div>
          ) : error ? (
            <div className="alert alert-danger text-center">
              <p>{error}</p>
            </div>
          ) : favorites.length === 0 ? (
            <div className="text-center py-5">
              <div className="text-muted">
                <i className="fas fa-thumbtack fa-3x mb-3"></i>
                <h4>No Favorites Yet</h4>
                <p>Pin stories to save them here for easy access.</p>
                <button 
                  className="btn btn-primary mt-3"
                  onClick={() => navigate('/')}
                >
                  Browse Stories
                </button>
              </div>
            </div>
          ) : (
            <div className="row g-4">
              {favorites.map((favorite, index) => (
                <div key={`favorite-${favorite.article_id}-${favorite.story_type}-${index}`} className="col-lg-6">
                  <StoryCard 
                    story={{
                      id: favorite.id,
                      article_id: favorite.article_id,
                      article: favorite.article,
                      story_type: favorite.story_type,
                      displayType: favorite.story_type,
                      // StoryCard will handle missing AI fields gracefully
                      ai_takeaway_title: favorite.article?.title,
                      ai_summary: favorite.article?.summary
                    }}
                    type={favorite.story_type}
                    storyType={favorite.story_type}
                    isPublic={false}
                    authUser={authUser}
                  />
                </div>
              ))}
            </div>
          )}
        </div>
      </section>
    </div>
  );
};

export default Favorites;

